/* eslint-disable */ 
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';
import download from 'downloadjs'

// URL functions
import { fetchKardiaRxIdtfEcg, getEKGDownloadReport } from 'legacy/containers/ApiUrls';

// Constants Types
import ROUTE_PATHS from '../../../routes/routePaths';
import {
  IDTF_ECG_TABLE_DATA_REQUEST,
  IDTF_ECG_TABLE_DATA_SUCCESS,
  IDTF_ECG_TABLE_DATA_FAILURE,
  IDTF_SELECTED_PATIENT,
  IDTF_SELECTED_RECORDING,
} from './types';

import history from '../../../legacy/containers/History';

// ------------------------------------
// Actions
// ------------------------------------
export const kardiRxIdtfEcgTableDataRequest = () => ({
  type: IDTF_ECG_TABLE_DATA_REQUEST,
});
export const kardiRxIdtfEcgTableDataSuccess = data => ({
  type: IDTF_ECG_TABLE_DATA_SUCCESS,
  payload: data,
});
export const kardiRxIdtfEcgTableDataFailure = () => ({
  type: IDTF_ECG_TABLE_DATA_FAILURE,
});

export const updateRxPatient = patient => ({
  type: IDTF_SELECTED_PATIENT,
  payload: patient,
});

export const updateRxRecording = rec => ({
  type: IDTF_SELECTED_RECORDING,
  payload: rec,
});

export const setInitialKardiaRxEcgTableData = (match, location) => (
  dispatch,
  getState,
) => {
  const {
    id,
    participantId,
    connectionTemplateID,
  } = getState().kardiaRx.kardiaRxIDTFEcg.selectedPatinet;
  const { patientId } = match.params;
  const { search } = location;
  const templetArr = search.split('idtf_connection_id=');
  dispatch(
    updateRxPatient({
      connectionId: id,
      participantId: patientId,
      idtf_connection_id: templetArr[1],
    }),
  );
};

export const getKardiaRxEcgTableData = (id, forceUpdate = false) => (
  dispatch,
  getState,
) => {
  dispatch(kardiRxIdtfEcgTableDataRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  const {
    idtf_connection_id,
  } = getState().kardiaRx.kardiaRxIDTFEcg.selectedPatinet;
  const enrolled_idtf_connection_id = getState().app && getState().app.dataSources
      && getState().app.dataSources.enrolledPatientOverview
      && getState().app.dataSources.enrolledPatientOverview.data
      && getState().app.dataSources.enrolledPatientOverview.data.latest_enrollment 
      && getState().app.dataSources.enrolledPatientOverview.data.latest_enrollment.idtf_connection_id;
  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;
      const apiCalls = [];
      if (idtf_connection_id || enrolled_idtf_connection_id) {
        apiCalls.push(
          apiCalls.push(dispatch(fetchKardiaRxIdtfEcg(idtf_connection_id || enrolled_idtf_connection_id))),
        );
      } else {
        apiCalls.push(dispatch(fetchKardiaRxIdtfEcg(id)));
      }
      return Promise.all(apiCalls);
    })
    .then(data => {
      if (id || idtf_connection_id) {
        return dispatch(kardiRxIdtfEcgTableDataSuccess(data));
      }
      return dispatch(kardiRxIdtfEcgTableDataSuccess([]));
    })
    .catch(err => {
      // console.log('getKardiaRxEcgTableData', err);
      dispatch(kardiRxIdtfEcgTableDataSuccess([]));
      dispatch(kardiRxIdtfEcgTableDataFailure(err));
    });
};

export const updatedSelectedKardiaRxPatient = data => dispatch => {
  dispatch(updateRxPatient(data));
};

export const updatedSelectedRxRecording = data => dispatch => {
  dispatch(updateRxRecording(data));
};

export const routeChangeAction = RecordingID => (dispatch, getState) => {
  const {
    idtf_connection_id,
  } = getState().kardiaRx.kardiaRxIDTFEcg.selectedPatinet;
  const { selectedPatientId } = getState().patientFile;
  history.push(
    `${ROUTE_PATHS.PATIENTS_PATIENT_FILE}/${selectedPatientId}/recordings/ekg/${RecordingID}/${idtf_connection_id}`,
  );
};

export const getKardiaRxEcgTableDownloadReport = (id, forceUpdate = false) => (
  dispatch,
  getState,
) => {

  // dispatch(dataRequest())
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)
 

  let promises
  if (meDataSource.data) {
    promises = Promise.resolve()
  } else {
    promises = dispatch(getMe())
  }

  return promises
    .then(() => {
      const apiCalls = []

      const me = getDataSource(getState(), DATASOURCES.ME)

      const {
        teams,
      } = me.data

      apiCalls.push(dispatch(getEKGDownloadReport(id)))
      return Promise.all(apiCalls)
      // return Promise.resolve('Success')
    })
    .then(res => {
      // eslint-disable-next-line no-empty
      if (res[0].errors) {
      } else {
        const blob = new Blob([ res[0] ], { type: 'application/pdf' })
        dispatch(getKardiaRxEcgTableData());
        download(blob, `${id}.pdf`, 'application/pdf')
      }
      // dispatch(updateStatusEosReport(res[0]))
    })
    // .then(() => dispatch(dataSuccess()))
    .catch(err => {
      // dispatch(updateStatusEosReport(err))
      console.log('getEKGDownloadReport', err)
      // dispatch(dataFailure())
    })

};



// WEBPACK FOOTER //
// ./src/views/state/kardiaRxIdtf/KardiaRxIDTFEcgTableActions.js